var styles = {"notifications":"styles_notifications__2w2L6 flex flex-column mt1"};

export default styles;
//# sourceMappingURL=styles.css.js.map
